import { getFaIcon } from '@odin-labs/components';
import { faTimes } from 'components/icons';

/** The leave action's icon in the router prompt's modals. */
export const PromptTimesIcon = getFaIcon({
  icon: faTimes,
  className: 'odin-text-odin-primary',
});
